import styled from '@emotion/styled'

import TemplateHeader from '@/components/templates/TemplateHeader'
import TemplateNavigation from '@/components/templates/TemplateNavigation'
import Menu from '@/components/templates/Menu'

const Layout = styled.div``

Layout.Header = styled(TemplateHeader)`
  display: flex;
  height: 70px !important;
`

Layout.HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

Layout.Logo = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  text-transform: capitalize;
`

Layout.LogoImage = styled.img`
  height: 70px;
  justify-self: flex-start;
`

Layout.LogoText = styled.h4`
  font-size: 22px;
  font-weight: 400;
`

Layout.Navigation = styled(TemplateNavigation)`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  align-items: center;
  gap: 3em;
`

Layout.SubHeader = styled.div`
  display: flex;
  background: ${({ theme }) => theme.palette.primary.main};
  color: ${({ theme }) => theme.palette.background.paper};
  height: 60px;
`

Layout.SubHeaderTitle = styled.span`
  margin: auto;
  color: ${({ theme }) => theme.palette.secondary.main};
`

Layout.Menu = styled(Menu)`
  font-size: 15px;
  font-family: ${({ fontFamily }) => fontFamily} !important;
  gap: 40px;
  align-items: center;
  display: flex;
  margin: 0 auto;
  justify-content: center;
  padding: 20px 0;
  text-transform: uppercase;
  width: 100%;
  p {
    font-weight: 500;
  }
`

export default Layout
